export default __webpack_public_path__ + "static/image-8ee9fd29647eef24361a9b9df25f335c.svg";